var _excluded = ["inverse", "locale", "className"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { StrictMode } from 'react';
import Types from 'prop-types';
import classNames from 'classnames';
import { useTheme } from '@wise/components-theming';
import getItems from './items';
import { Locale, LocaleValues } from '../common/l10n';
import FooterTop from './FooterTop';
import FooterDivider from './FooterDivider';
import FooterBottom from './FooterBottom';
import FooterSmall from './FooterSmall';
import MobileLogo from './MobileLogo';
var Footer = function Footer(_ref) {
  var inverse = _ref.inverse,
    localeProp = _ref.locale,
    className = _ref.className,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var locale = LocaleValues.includes(localeProp) ? localeProp : Footer.defaultProps.locale;
  var items = getItems(locale);
  var _useTheme = useTheme(),
    isModern = _useTheme.isModern;
  var footerClass = classNames('footer p-y-section-5', className, {
    'footer-inverse': !isModern && inverse
  });
  return /*#__PURE__*/React.createElement(StrictMode, null, /*#__PURE__*/React.createElement("footer", _extends({
    className: footerClass
  }, otherProps), /*#__PURE__*/React.createElement("div", {
    className: "container"
  }, /*#__PURE__*/React.createElement(MobileLogo, {
    locale: locale,
    inverse: inverse
  }), /*#__PURE__*/React.createElement(FooterTop, {
    sections: items.top
  }), /*#__PURE__*/React.createElement(FooterDivider, null), /*#__PURE__*/React.createElement(FooterBottom, {
    items: items.bottom,
    inverse: inverse,
    locale: locale
  }), /*#__PURE__*/React.createElement(FooterSmall, {
    items: items.small
  }))));
};
Footer.defaultProps = {
  inverse: false,
  locale: Locale.GB,
  className: ''
};
export default Footer;